// extracted by mini-css-extract-plugin
export default {"contacts":"styles_contacts__uXYdK","contactItem":"styles_contactItem__CP62Q"};